const servers = 20408;
const capacity = 23877.359999999997;
const countries = 148;
const locations = 194;
export { servers, capacity, countries, locations };
